import { Participant, Conversation } from '@app/models'

export const shouldFallbackToAccount = (participant: Participant | null, conversation: Conversation | null) => {
  return participant?.role === 'MainAgent' && conversation?.showContact === false
}